import apiClient, { unwrapData } from "./apiClient";

export async function getPhoneNumbers(params = {}, options = {}) {
  const response = await apiClient.get("/api/phone-numbers", {
    ...options,
    query: {
      page: params.page,
      limit: params.limit,
      search: params.search,
    },
  });
  const data = unwrapData(response) || {};

  return {
    items: Array.isArray(data.items) ? data.items : [],
    meta: response?.meta || {},
  };
}

export async function createPhoneNumber(payload = {}, options = {}) {
  const response = await apiClient.post("/api/phone-numbers", {
    ...options,
    body: payload,
  });
  return unwrapData(response);
}

export async function updatePhoneNumber(phoneNumberId, payload = {}, options = {}) {
  const response = await apiClient.put(`/api/phone-numbers/${encodeURIComponent(phoneNumberId)}`, {
    ...options,
    body: payload,
  });
  return unwrapData(response);
}
